(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slider"] && !Shopify.designMode) return;
  try {
    
const slider = document.getElementById('collection-slider');
const dots = document.querySelectorAll('.slider-dot');

slider.addEventListener('scroll', () => {
  const itemWidth = slider.querySelector('.collection-item').offsetWidth + 24;
  const scrollLeft = slider.scrollLeft;
  const index = Math.round(scrollLeft / itemWidth);
  dots.forEach(dot => dot.classList.remove('active'));
  if (dots[index]) dots[index].classList.add('active');
});

  } catch(e) { console.error(e); }
})();
})();
